<template>
  <div id="app">
    <Header></Header>
    <rightNav></rightNav>
    <router-view />
    <Footer></Footer>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue